exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table tbody tr td:nth-of-type(6){display:table-cell}.categories-box{display:flex;flex-wrap:wrap;gap:20px}.section-title{font-weight:600;text-transform:uppercase;color:rgba(0,0,0,.72);font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/faq/faq-list.scss
// module id = 801
// module chunks = 0